// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=ff653639-31b3-4211-98d0-ecceecdc6bb6";
};